import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FONT_SIZES} from '../../../../../constants/typography';
import {ImageIcon} from '../../../../atoms/Image/ImageIcon';
import {Text} from '../../../../atoms/Text/Text';
import {Toggle} from '../../../../atoms/Toggle/Toggle';

export interface Props {
  active: boolean;
  label: string;
  sublabel?: string;
  className?: string;
  onToggle: () => void;
  dataTestId?: string;
}

export const FilterDropdownBoolean: FC<
  Props & FilterDropdownBooleanWithIconProps
> = ({
  active,
  label,
  onToggle,
  dataTestId = 'filterDropdownBoolean',
  sublabel,
  icon,
  className,
}) => {
  return (
    <Wrapper data-testid={dataTestId} className={className}>
      <Label $isActive={active} data-testid={`${dataTestId}Label`}>
        <FilterDropdownBooleanWithIcon icon={icon} label={label} />
        <StyledToggle
          checked={active}
          onChange={onToggle}
          aria-label={label}
          tabIndex={-1}
        />
      </Label>
      {sublabel && <Text color="Grey1">{sublabel}</Text>}
    </Wrapper>
  );
};

interface FilterDropdownBooleanWithIconProps {
  icon?: {
    description: string;
    url: string;
    aspectRatio?: {height?: number; width?: number};
  };
}

const FilterDropdownBooleanWithIcon: FC<
  FilterDropdownBooleanWithIconProps & {label: string}
> = ({icon, label}) => {
  if (!icon) {
    return <>{label}</>;
  }

  return (
    <IconLabelWrapper>
      <ImageIcon url={icon.url} description={icon.description} />
      {label}
    </IconLabelWrapper>
  );
};

const IconLabelWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  border: solid 1px ${COLORS.Grey3};
  background-color: ${COLORS.White};
  border-radius: 4px;
  padding: 0 0.5rem;
  height: 32px;
`;

export const Label = styled.label<{$isActive?: boolean}>`
  align-items: center;
  color: ${({$isActive}) => ($isActive ? COLORS.Black : COLORS.Grey1)};
  cursor: pointer;
  display: flex;
  font-size: ${FONT_SIZES.px14};
`;

const StyledToggle = styled(Toggle)`
  margin-left: 0.3rem;
`;
